<template>
  <el-form
      ref="form"
      style="height: 100%"
      :model="form">
    <gj-table
        :index="false"
        adapt-parent
        :loading="loading"
        name="deliveryOrderProductForm"
        border
        :show-overflow="false"
        :data="form.items"
        :columns="columns"
        :auto-resize="false"
        :adapt-height-listen-update="false"
        :offset-height="87">
      <template v-slot:sku="{row}">
        <div>
          <gj-text>{{row.productName | defaultShow}}</gj-text>
        </div>
        <div>{{row.sku | defaultShow}}</div>
        <div>{{row.productType | optionText(productTypeOption)}} - {{row.categoryName | defaultShow}}</div>
      </template>
      <template v-slot:deliveryQuantity="{row, index}">
        <el-form-item
            v-if="editOpType"
            :prop="`items.${index}.deliveryQuantity`"
            :rules="[
              $gjRequired('请输入交货量'),
              $gjReRule(RE.pt0, '请输入大于等于0的整数'),
              $gjCustomRule(lessDeliveryQuantityValidator(row.inboundQuantity), '需大于等于入库量'),
              $gjCustomRule(moreDeliveryQuantityValidator(row.originQuantity, row.notDeliveryQuantity), '增加数量需小于等于未交量'),
            ]"
            class="gj-table-item">
          <gj-input
              v-model="form.items[index].deliveryQuantity"
              @input="quantityInput(index)"
              width="100%">
          </gj-input>
        </el-form-item>
        <template v-else>{{row.deliveryQuantity | defaultShow}}</template>
      </template>
      <template v-slot:expectDeliveryDate="{row, index}">
        <el-form-item
            v-if="editOpType"
            :prop="`items.${index}.expectDeliveryDate`"
            :rules="[
              $gjRequired('请输入预计交货日期'),
            ]"
            class="gj-table-item">
          <gj-date-picker
              v-model="form.items[index].expectDeliveryDate"
              :clearable="false">
          </gj-date-picker>
        </el-form-item>
        <template v-else>{{row.expectDeliveryDate | defaultShow}}</template>
      </template>
      <template v-slot:actualDeliveryDate="{row, index}">
        <el-form-item
            v-if="editOpType"
            :prop="`items.${index}.actualDeliveryDate`"
            :rules="[
              $gjRequired('请输入实际交货日期'),
            ]"
            class="gj-table-item">
          <gj-date-picker
              v-model="form.items[index].actualDeliveryDate"
              :clearable="false">
          </gj-date-picker>
        </el-form-item>
        <template v-else>{{row.actualDeliveryDate | defaultShow}}</template>
      </template>
      <template #footer>
        <div v-gutter="20"
             class="default">
          <span>产品种类数：{{form.items.length}}</span>
          <span>交货量合计：{{form.items | sum('deliveryQuantity')}}</span>
          <span>总金额合计：{{form.items | sum('amount') | amount | defaultShow(currencySymbol)}}</span>
        </div>
      </template>
    </gj-table>
  </el-form>
</template>

<script>
  import {formRuleMixin, opTypeMixin} from "../../../../../../minxins";
  import {ProductEnum} from "../../../../../../utils/options";
  import {isMeaningful, toFixed} from "../../../../../../utils/common";
  export default {
    name: "app-delivery-order-product",
    mixins: [formRuleMixin, opTypeMixin],
    props: {
      form: {
        required: true
      }
    },
    data() {
      return {
        tableData: [],
        loading: false,
        columns: [],
        productTypeOption: ProductEnum.typeOption,
        lessDeliveryQuantityValidator: (inboundQuantity) => {
          return (quantity) => Number(quantity) >= inboundQuantity;
        },
        moreDeliveryQuantityValidator: (originQuantity, notDeliveryQuantity) => {
          return (quantity) => originQuantity + notDeliveryQuantity >= Number(quantity);
        }
      }
    },
    created() {
      this.columns = [
        {id: 'purchaseOrderCode', header: '采购单号', field: 'purchaseOrderCode', width: '135px', fixed: 'left'},
        {id: 'picture', header: '图片', field: 'picture:smallImageUrl', width: '60px', fixed: 'left'},
        {id: 'sku', header: '产品名称/SKU/产品类型-品类', field: 'slot:sku', minWidth: '200px', fixed: 'left'},
        {id: 'deliveryQuantity', header: '交货量', field: 'slot:deliveryQuantity', width: this.editOpType ? '165px' : '80px',
          align: this.editOpType ? 'left' : 'right'},
        this.editOpType ? {id: 'notDeliveryQuantity', header: '未交量', field: 'notDeliveryQuantity', width: '90px', align: 'right'} : null,
        {id: 'includeTaxPrice', header: '含税单价', field: 'includeTaxPrice', prefix: 'currencySymbol', width: '90px', align: 'right'},
        {id: 'amount', header: '金额', field: 'amount', prefix: 'currencySymbol', width: '100px', align: 'right'},
        {id: 'inboundQuantity', header: '入库量', field: 'inboundQuantity', width: '80px', align: 'right'},
        {id: 'expectDeliveryDate', header: '预计交货日期', field: 'slot:expectDeliveryDate', width: '150px'},
        {id: 'actualDeliveryDate', header: '实际交货日期', field: 'slot:actualDeliveryDate', width: '150px'},
      ].filter(item => item !== null);
    },
    computed: {
      currencySymbol() {
        if (this.form.items.length > 0) {
          return this.form.items[0].currencySymbol;
        }
        return '';
      }
    },
    methods: {
      quantityInput(index) {
        const deliveryQuantity = this.form.items[index].deliveryQuantity;
        if (isMeaningful(deliveryQuantity)) {
          if (this.RE.pt.test(deliveryQuantity)) {
            const tmp = Number(this.form.items[index].includeTaxPrice) * Number(deliveryQuantity);
            this.form.items[index].amount = toFixed(tmp);
          } else {
            this.form.items[index].amount = '-';
          }
        } else {
          this.form.items[index].amount = 0;
        }
      },
      formValidate() {
        return this.$gjFormValidate();
      }
    }
  }
</script>

<style scoped>

</style>
